import * as yup from 'yup';

export const schema = yup.object().shape({
	userType: yup.string().required('Kullanıcı tipi seçmelisiniz'),
	firstName: yup
		.string()
		.required('Ad alanı zorunludur')
		.min(2, 'En az 2 karakter girmelisiniz')
		.max(30, 'Ad en fazla 30 karakter olabilir')
		.matches(/^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/, 'Ad sadece harflerden oluşmalıdır'),
	lastName: yup
		.string()
		.required('Soyad alanı zorunludur')
		.min(2, 'En az 2 karakter girmelisiniz')
		.max(30, 'Soyad en fazla 30 karakter olabilir')
		.matches(/^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/, 'Soyad sadece harflerden oluşmalıdır'),
	phone: yup
		.string()
		.required('Telefon numarası zorunludur')
		.matches(/^[0-9]+$/, 'Geçerli bir telefon numarası giriniz'),
	acceptTerms: yup.boolean().oneOf([true], 'Kullanım koşullarını kabul etmelisiniz').required('Açık rıza metnini onaylamanız gerekmektedir'),
	acceptMarketing: yup.boolean()
});
